import React,{useEffect} from 'react';
import { Canvas, useThree } from "@react-three/fiber";
import Model from "./Model";
import { Suspense } from "react";
import { useProgress, Html, ScrollControls } from "@react-three/drei";

// Cargar el progreso mientras se carga el modelo
function Loader() {
    const { progress } = useProgress();
    return <Html center>{progress.toFixed(1)} % loaded</Html>;
}

const Scene = ({ containerSize }) => {

    return (
        <Canvas
          gl={{ antialias: true }}
          dpr={[1, 1.5]}
          style={{ width: '100%', height: '100%' }}  // Asegura que el Canvas ocupe todo el contenedor
        >
          <directionalLight position={[-5, -5, 5]} intensity={4} />
          <Suspense fallback={<Loader />}>
            {/* Ajustar la cámara dinámicamente según el tamaño del contenedor */}
            <CameraAdjuster containerSize={containerSize} />
            <Model containerSize={containerSize}/>
          </Suspense>
        </Canvas>
      );
    return (

        <Canvas
            gl={{ antialias: true }}
            dpr={[1, 1.5]}
            className="w-full h-full"
            style={{ width: '100%', height: '100%' }}
        // camera={{ position: [0, 0, 0], fov: 50 }}
        //camera={{ position: [0, 1.1, 5] }}

        >
            <directionalLight position={[-5, -5, 5]} intensity={4} />
            <Suspense fallback={<Loader />}>
                <Model />
            </Suspense>
        </Canvas>
    );

    return (
        <Canvas gl={{ antialias: true }} dpr={[1, 1.5]} className="w-full h-full">
            <directionalLight position={[-5, -5, 5]} intensity={4} />
            <Suspense fallback={<Loader />}>
                <ScrollControls damping={0.5} pages={3}>
                    <Model />
                </ScrollControls>
            </Suspense>
        </Canvas>
    );
}



const CameraAdjuster = ({ containerSize }) => {
    const { camera, gl } = useThree();

    useEffect(() => {
        console.log("containerSizs--",containerSize)
        // Ajustar el campo de visión (FOV) y la posición de la cámara según el tamaño del contenedor
        const aspect = containerSize.width / containerSize.height;
        camera.aspect = aspect;
        camera.updateProjectionMatrix();

        // Configurar un FOV dinámico
        const newFov = Math.min(75, 75 * (containerSize.width / 300)); // Ajusta según sea necesario
        camera.fov = newFov;
        camera.position.set(0, 0, 5);  // Ajusta la posición en el eje Z

        gl.setSize(containerSize.width, containerSize.height); // Ajusta el tamaño del canvas

    }, [containerSize, camera, gl]);

    return null;
};

export default Scene;